import { KonvaEventObject } from "konva/lib/Core";
import { fireStateEvent } from "../events";
import { WhiteboardShape } from "../shapes";

export function draggable<Shape extends WhiteboardShape>(shape: Shape): void {
  shape.draggable(true);
  shape.on("mouseover", () => {
    if (!document.body.style.cursor || document.body.style.cursor === "default") {
      document.body.style.cursor = "pointer";
    }
  });
  shape.on("mouseout", () => (document.body.style.cursor = "default"));
  shape.on("dragend", (evt: KonvaEventObject<DragEvent>) => {
    shape.getStage().fire("state-shapeDragEnd");
    fireStateEvent("stateChange", evt, shape, { state: shape.state, changes: { position: shape.position() } });
  });
}
